export enum MarkupTypes {
  Percent = "percent",
  Amount = "amount",
}
